import { IParameterGroup } from '@/pages/Parameters/parameters.types.ts'
import confirmService from '@/services/ConfirmService/confirm.service.ts'
import parametersApi from '@/pages/Parameters/parameters.api.ts'
import parameterGroupsEvents from '@/pages/Parameters/events/groups/paramterGroups.events.ts'
import { useCallback } from 'react'
import useParameterGroups from '@/pages/Parameters/hooks/useParameterGroups.ts'

/**
 * Возвращает колбек, принимающий groupId, при вызове которого пользователя попросят подтвердить удаление группы
 * */
const useRequestDeleteParameterGroup = () => {
  const groups = useParameterGroups()

  return useCallback(
    (groupId: IParameterGroup['id']) => {
      const group = groups.find((g) => g.id === groupId)

      confirmService.requestConfirm({
        buttonType: 'primary',
        description: `Вы действительно хотите удалить группу "${group.name}"?`,
        onConfirm: () =>
          parametersApi.deleteGroup(group.id).then((r) => {
            if (r.status === 'success') {
              parameterGroupsEvents.deleted(r.body.id)
            }
          }),
      })
    },
    [groups]
  )
}

export default useRequestDeleteParameterGroup
